import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { InternationalCurrenciesEffects } from './international-currencies.effects';
import { STORE_TYPE } from './international-currencies.model';
import { internationalCurrenciesReducer } from './international-currencies.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(STORE_TYPE, internationalCurrenciesReducer),
    EffectsModule.forFeature([InternationalCurrenciesEffects]),
  ],
})
export class UIInternationalCurrenciesStoreModule {}
